const Logo = new URL('../../images/Logo_Kestrix_Colour_dark.png', import.meta.url).href

export const KestrixLogo = () =>{
    return (
        <img
        src={Logo}
        alt='Kestrix'
        style={{
          width: 48,
          height: 48,
          objectFit: "contain",
        }}
      />
    )
}